import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApiError, ActionError } from '../../types/error.types';

interface ErrorState {
    errors: { [key: string]: ActionError };
}

const initialState: ErrorState = {
    errors: {}
};

const errorSlice = createSlice({
    name: 'error',
    initialState,
    reducers: {
        setError: (state, action: PayloadAction<{ error: ApiError; actionType: string }>) => {
            state.errors[action.payload.actionType] = {
                error: action.payload.error,
                actionType: action.payload.actionType
            };
        },
        clearError: (state, action: PayloadAction<string | undefined>) => {
            if (action.payload) {
                // Clear specific error
                const { [action.payload]: _, ...rest } = state.errors;
                state.errors = rest;
            } else {
                // Clear all errors
                state.errors = {};
            }
        },
    },
});

// Action creators
export const { setError, clearError } = errorSlice.actions;

// Helper function to create standardized error actions
export const createErrorAction = (error: any, actionType: string) => {
    const apiError: ApiError = {
        statusCode: error?.response?.status || error?.statusCode || 500,
        errorMessage: error?.response?.data?.errorMessage || error?.errorMessage || error?.message || 'An unknown error occurred'
    };

    return setError({
        error: apiError,
        actionType
    });
};

export default errorSlice.reducer;